import { type } from "arktype";

export const pageInteger = type("number.integer >= 1");

export const pagination = type({ page: pageInteger.default(1) });
